"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCompanyLocationStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../../common/utils/fetch"));
const i18n_1 = __importDefault(require("../../../common/i18n"));
exports.useCompanyLocationStore = (0, pinia_1.defineStore)("companyLocationStore", {
    state: () => ({
        companies: [],
        locations: [],
        selectedCompany: null,
        selectedLocation: null,
        isLoading: false,
    }),
    getters: {},
    actions: {
        async getCompanies() {
            this.companies = [];
            this.locations = [];
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)("/api/get/companies", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    //body: JSON.stringify({ userCode: userCode }),
                })
                    .then(async (response) => {
                    if (typeof response.error !== "undefined") {
                        // refresh failed
                        reject(i18n_1.default.trans("frontend_location_error", "No Companies found!", "frontend"));
                        return;
                    }
                    await response.forEach((item) => {
                        const { name, id, firstLocationName } = item;
                        this.companies.push({ id, name, firstLocationName });
                    });
                    //kiolvassa a location-t a session storageből
                    const selectedCompany = sessionStorage.getItem("selectedCompany");
                    let isSelected = false;
                    if (selectedCompany) {
                        const storedCompany = JSON.parse(selectedCompany);
                        this.companies.forEach((item) => {
                            if (item.id === storedCompany.id) {
                                this.selectedCompany = item;
                                isSelected = true;
                            }
                        });
                    }
                    if (!isSelected && this.companies[0]) {
                        this.selectedCompany = this.companies[0];
                    }
                    else {
                        this.selectedCompany = null;
                    }
                    if (this.selectedCompany) {
                        this.getLocationsByCompany(this.selectedCompany);
                    }
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        },
        async getLocationsByCompany(company) {
            if (this.isLoading)
                return;
            this.selectedCompany = company;
            this.selectedLocation = null;
            this.isLoading = true;
            let isSelected = false;
            sessionStorage.setItem("selectedCompany", JSON.stringify(company));
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)("/api/get/company/locations/" + company["id"], {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    //body: JSON.stringify({ userCode: userCode }),
                })
                    .then(async (response) => {
                    if (typeof response.error !== "undefined") {
                        reject(i18n_1.default.trans("frontend_location_error", "No  locations found!", "frontend"));
                        return;
                    }
                    this.locations = [];
                    await response.forEach((item) => {
                        const { name, id, address } = item;
                        this.locations.push({ id, name, address });
                    });
                    //kiolvassa a location-t a session storageből
                    const selectedLocation = sessionStorage.getItem("selectedLocation");
                    isSelected = false;
                    if (selectedLocation) {
                        const storedLocation = JSON.parse(selectedLocation);
                        for (let item of this.locations) {
                            if (item.id === storedLocation.id) {
                                this.selectedLocation = item;
                                isSelected = true;
                                break;
                            }
                        }
                    }
                    if (!isSelected && this.locations[0]) {
                        this.selectedLocation = this.locations[0];
                    }
                    this.isLoading = false;
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        },
        selectLocation(location) {
            this.selectedLocation = location;
            sessionStorage.setItem("selectedLocation", JSON.stringify(location));
        },
        //kiolvassa a session storaget oldal újratöltésnél
        async readStorage() {
            const selectedCompany = sessionStorage.getItem("selectedCompany");
            const selectedLocation = sessionStorage.getItem("selectedLocation");
            await this.getCompanies();
            if (selectedCompany) {
                this.selectedCompany = JSON.parse(selectedCompany);
                await this.getLocationsByCompany(JSON.parse(selectedCompany));
            }
            let isSelected = false;
            if (selectedLocation) {
                const storedLocation = JSON.parse(selectedLocation);
                this.locations.forEach((item) => {
                    if (item.id === storedLocation.id) {
                        this.selectedLocation = item;
                        isSelected = true;
                    }
                });
                if ((!isSelected && this.locations[0]) ||
                    !this.selectedLocation) {
                    this.selectedLocation = this.locations[0];
                }
            }
        },
    },
});
